export const ME_DEMO = {
  id: 'usr_demo',
  email: 'owner@centrio.com',
  name: 'Demo Owner',
  mode: 'owner',
  memberships: [
    {
      tenantId: 'tnt_demo',
      role: 'owner',
      tenantName: 'Centrio',
      tenantSlug: 'centrio',
      tenantStatus: 'active',
    },
  ],
}
